import React from 'react'
import { Helmet } from 'react-helmet-async'
import EventsContent from '@/components/events-content'

export default function Events() {
  return (
    <>
      <Helmet>
        <title>Események | BeArt Művészetterápia</title>
        <meta name="description" content="BeArt Művészetterápia események - művészetterápiás csoportok, egyéni és csoportos alkalmak" />
        <meta property="og:title" content="Események | BeArt Művészetterápia" />
        <meta property="og:description" content="BeArt Művészetterápia események - művészetterápiás csoportok, egyéni és csoportos alkalmak" />
        <link rel="canonical" href="https://beart.hu/events" />
      </Helmet>
      
      <EventsContent />
    </>
  )
}
